import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appSetTabIndex]',
  standalone: false,
})
export class SetTabIndexDirective {
  private readonly el = inject(ElementRef);

  constructor() {
    setTimeout(() => {
      (this.el.nativeElement as HTMLElement).setAttribute('tabindex', '-1');
    }, 500);
  }
}
